var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoralislogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.5571 29.9816C21.7959 32.0719 18.3109 32.3996 14.5811 31.6738C8.03046 30.3984 4.30488 24.4758 5.08406 18.1198C5.90582 11.4195 12.0988 7.24506 18.9262 8.3483C20.3568 8.57848 21.6873 9.03886 22.8902 9.68172C24.6316 10.6128 26.7584 10.5154 28.3721 9.38932L28.5105 9.29393C30.1242 7.67848 30.1242 5.48445 28.751 4.04113C26.5945 1.7766 23.3309 0.652626 19.948 0.175664C10.8512 -1.11006 2.21005 4.79389 0.362165 13.5658C-1.639 23.0636 4.86691 32.1964 14.596 33.7683C18.6388 34.4215 22.5879 33.6646 25.9132 31.8646C26.5008 31.5473 26.6924 30.809 26.3241 30.2595C25.9366 29.6768 25.1213 29.5544 24.5571 29.9816Z",
    fill: "url(#paint0_linear_1525_11550)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.6,
    d: "M24.5571 29.9816C21.7959 32.0719 18.3109 32.3996 14.5811 31.6738C8.03046 30.3984 4.30489 24.4758 5.08406 18.1198C5.90582 11.4195 12.0988 7.24506 18.9262 8.3483C20.3568 8.57848 21.6873 9.03886 22.8902 9.68172C24.6316 10.6128 26.7584 10.5154 28.3721 9.38932L28.5105 9.29393C29.9368 7.86097 30.3115 5.66694 28.751 4.04113C26.5838 1.78696 23.3309 0.652626 19.948 0.175664C10.8512 -1.11006 2.21005 4.79389 0.362165 13.5658C-1.639 23.0636 4.86691 32.1964 14.596 33.7683C18.6388 34.4215 22.5879 33.6646 25.9132 31.8646C26.5008 31.5473 26.6924 30.809 26.3241 30.2595C25.9366 29.6768 25.1213 29.5544 24.5571 29.9816Z",
    fill: "url(#paint1_linear_1525_11550)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.53725 18.4143C5.72092 11.7658 12.0991 7.24506 18.9286 8.3483C20.3592 8.57848 21.6898 9.03885 22.8926 9.68172C24.6341 10.6128 26.7608 10.5154 28.3745 9.38932C28.4661 9.32503 28.5534 9.25453 28.63 9.17158C30.2969 7.38815 29.9137 5.09251 28.7535 4.04113C26.433 1.93627 23.3333 0.652626 19.9505 0.175664C10.8537 -1.11006 2.21249 4.79389 0.364606 13.5658C-1.63656 23.0636 4.86936 32.1964 14.5984 33.7683C17.2787 34.2017 19.9143 34.0109 22.3583 33.312C7.73273 36.18 3.61969 23.5675 4.53725 18.4143Z",
    fill: "url(#paint2_linear_1525_11550)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.6,
    d: "M4.53725 18.4143C5.72092 11.7658 12.0991 7.24506 18.9286 8.3483C20.3592 8.57848 21.6898 9.03885 22.8926 9.68172C24.6341 10.6128 26.7608 10.5154 28.3745 9.38932L28.5129 9.29393C30.1266 7.67848 29.9393 5.30196 28.7535 4.04113C26.7055 1.86577 23.3333 0.652626 19.9505 0.175664C10.8537 -1.11006 2.21249 4.79389 0.364606 13.5658C-1.63656 23.0636 4.86936 32.1964 14.5984 33.7683C17.2787 34.2017 19.9143 34.0109 22.3583 33.312C7.73273 36.18 3.61969 23.5675 4.53725 18.4143Z",
    fill: "url(#paint3_linear_1525_11550)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.01219 7.79489C15.682 4.97667 20.4167 7.52945 23.0842 9.36886C24.5787 10.3995 26.3116 10.6069 27.8402 9.76287C28.0743 9.6343 28.2894 9.4767 28.4959 9.30872C28.5065 9.29835 28.5193 9.29006 28.5299 9.27762C30.3161 7.47968 29.9989 5.0928 28.6279 3.83818C26.3265 1.73126 23.3567 0.663279 19.9909 0.18217C10.777 -1.13881 2.03153 4.93105 0.307119 13.8461C-0.369871 17.3486 0.107002 20.7911 1.46737 23.8125C-1.31723 17.3258 2.34022 10.6131 9.01219 7.79489Z",
    fill: "url(#paint4_linear_1525_11550)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M28.0864 8.88939L27.948 8.98478C26.3237 10.117 24.0628 9.53018 22.4342 8.40621C19.7667 6.5668 15.445 4.38729 8.77518 7.20551C2.10321 10.0258 -1.48614 16.9148 1.30059 23.3994C1.25801 23.3061 1.21969 23.2128 1.18137 23.1195C1.29421 23.4119 1.4113 23.7022 1.53903 23.9863C-1.24557 17.5017 2.34377 10.6127 9.01361 7.79238C15.6835 4.97416 20.399 7.6327 22.9983 9.32073C24.1245 10.0528 25.8127 10.9652 28.2525 9.50322L28.6272 9.13824C29.8683 7.88777 30.045 6.01522 29.2956 4.73572C29.6809 6.0401 29.3276 8.02464 28.0864 8.88939Z",
    fill: "url(#paint5_linear_1525_11550)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M29.2063 28.1297C29.6321 28.8659 29.202 29.7866 28.3356 29.9484C27.814 30.0458 27.2732 29.797 27.0135 29.347C26.5877 28.6108 27.0178 27.6901 27.8842 27.5283C28.4037 27.4309 28.9465 27.6797 29.2063 28.1297Z",
    fill: "url(#paint6_linear_1525_11550)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M31.12 25.8776C31.3606 26.3857 31.0753 26.985 30.509 27.1281C30.0854 27.2338 29.6298 27.0202 29.4467 26.6345C29.2062 26.1264 29.4914 25.5271 30.0577 25.384C30.4814 25.2803 30.937 25.4919 31.12 25.8776Z",
    fill: "url(#paint7_linear_1525_11550)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M31.6568 24.7164C31.9849 24.7164 32.2508 24.4573 32.2508 24.1378C32.2508 23.8182 31.9849 23.5592 31.6568 23.5592C31.3288 23.5592 31.0629 23.8182 31.0629 24.1378C31.0629 24.4573 31.3288 24.7164 31.6568 24.7164Z",
    fill: "url(#paint8_linear_1525_11550)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M32.4446 22.5535C32.6786 22.5535 32.8682 22.3687 32.8682 22.1408C32.8682 21.9129 32.6786 21.7281 32.4446 21.7281C32.2106 21.7281 32.0209 21.9129 32.0209 22.1408C32.0209 22.3687 32.2106 22.5535 32.4446 22.5535Z",
    fill: "url(#paint9_linear_1525_11550)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M32.7169 20.6437C32.8732 20.6437 33 20.5202 33 20.3679C33 20.2155 32.8732 20.092 32.7169 20.092C32.5605 20.092 32.4337 20.2155 32.4337 20.3679C32.4337 20.5202 32.5605 20.6437 32.7169 20.6437Z",
    fill: "url(#paint10_linear_1525_11550)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M4.53676 18.4142C5.30316 14.1111 8.24743 10.7019 12.0795 9.12793C8.01751 10.6065 4.86248 14.1174 4.06415 18.5946C3.16788 23.6234 7.06802 35.7631 20.8612 33.6686C21.3657 33.5712 21.866 33.4509 22.3556 33.3119C7.73224 36.1799 3.61921 23.5674 4.53676 18.4142Z",
    fill: "url(#paint11_linear_1525_11550)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1525_11550",
    x1: 1.23233,
    y1: 23.2599,
    x2: 31.8006,
    y2: 10.8363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A67B2",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0284,
    stopColor: "#4568AA",
    stopOpacity: 0.8057
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1215,
    stopColor: "#776A97",
    stopOpacity: 0.8243
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#9A6C87",
    stopOpacity: 0.844
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    stopColor: "#B56E78",
    stopOpacity: 0.8645
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4297,
    stopColor: "#CB6F6B",
    stopOpacity: 0.8859
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#DC7061",
    stopOpacity: 0.9087
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6671,
    stopColor: "#E8705A",
    stopOpacity: 0.9334
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8072,
    stopColor: "#EF7055",
    stopOpacity: 0.9614
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1525_11550",
    x1: 14.7131,
    y1: 12.6795,
    x2: 21.5403,
    y2: 29.4809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1098,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.239,
    stopColor: "#727171",
    stopOpacity: 0.8548
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4872,
    stopColor: "#928F8F",
    stopOpacity: 0.5757
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8262,
    stopColor: "#CFCDCD",
    stopOpacity: 0.1947
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1525_11550",
    x1: 15.1955,
    y1: 5.80641,
    x2: 14.0921,
    y2: 27.1091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0513,
    stopColor: "#CB6F6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1051,
    stopColor: "#A96D7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1611,
    stopColor: "#8B6B8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2187,
    stopColor: "#706A9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#5769A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3409,
    stopColor: "#4268AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4082,
    stopColor: "#3167AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4888,
    stopColor: "#2A67B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69ACDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1525_11550",
    x1: 23.2231,
    y1: 9.68251,
    x2: 10.2726,
    y2: 23.3089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1098,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.239,
    stopColor: "#727171",
    stopOpacity: 0.8548
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4872,
    stopColor: "#928F8F",
    stopOpacity: 0.5757
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8262,
    stopColor: "#CFCDCD",
    stopOpacity: 0.1947
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1525_11550",
    x1: -0.88567,
    y1: 13.5455,
    x2: 30.0959,
    y2: 7.96248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69ACDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0258,
    stopColor: "#609ED3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0745,
    stopColor: "#5488C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1254,
    stopColor: "#4979B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1787,
    stopColor: "#4270B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.236,
    stopColor: "#3D6AAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3045,
    stopColor: "#3C68AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3759,
    stopColor: "#4568AA",
    stopOpacity: 0.9897
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#5B69A3",
    stopOpacity: 0.9755
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5904,
    stopColor: "#776B98",
    stopOpacity: 0.9589
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.718,
    stopColor: "#996C88",
    stopOpacity: 0.9405
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8556,
    stopColor: "#C16F71",
    stopOpacity: 0.9208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37153",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1525_11550",
    x1: -1.17086,
    y1: 17.9835,
    x2: 29.6927,
    y2: 5.43988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69ACDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#5789AE",
    stopOpacity: 0.832
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4252,
    stopColor: "#3F6480",
    stopOpacity: 0.5748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6587,
    stopColor: "#2E4D63",
    stopOpacity: 0.3413
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    stopColor: "#234054",
    stopOpacity: 0.1419
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F3C4F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1525_11550",
    x1: 28.078,
    y1: 27.5054,
    x2: 28.1448,
    y2: 29.9667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1842,
    stopColor: "#E67661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7341,
    stopColor: "#C88485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC8993"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1525_11550",
    x1: 30.0482,
    y1: 25.3381,
    x2: 30.5153,
    y2: 27.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1842,
    stopColor: "#E67661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7341,
    stopColor: "#C88485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC8993"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1525_11550",
    x1: 31.5601,
    y1: 23.6184,
    x2: 31.7921,
    y2: 24.8967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1842,
    stopColor: "#E67661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7341,
    stopColor: "#C88485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC8993"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1525_11550",
    x1: 32.3774,
    y1: 21.7693,
    x2: 32.543,
    y2: 22.6819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1842,
    stopColor: "#E67661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7341,
    stopColor: "#C88485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC8993"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1525_11550",
    x1: 32.6733,
    y1: 20.1187,
    x2: 32.7838,
    y2: 20.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1842,
    stopColor: "#E67661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7341,
    stopColor: "#C88485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC8993"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1525_11550",
    x1: 13.8325,
    y1: 31.575,
    x2: 10.9542,
    y2: 11.8319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37153",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0244,
    stopColor: "#D66954",
    stopOpacity: 0.3903
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0761,
    stopColor: "#AC5F56",
    stopOpacity: 0.3696
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1334,
    stopColor: "#8A5656",
    stopOpacity: 0.3466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1953,
    stopColor: "#6E4F55",
    stopOpacity: 0.3219
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2628,
    stopColor: "#574954",
    stopOpacity: 0.2949
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3381,
    stopColor: "#444452",
    stopOpacity: 0.2648
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4245,
    stopColor: "#354051",
    stopOpacity: 0.2302
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5286,
    stopColor: "#293E50",
    stopOpacity: 0.1886
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6688,
    stopColor: "#213C50",
    stopOpacity: 0.1325
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F3C4F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoralislogo);
export default __webpack_public_path__ + "static/media/coralislogo.a51af35f2bf3d82471a591140d95e437.svg";
export { ForwardRef as ReactComponent };